module.exports = __webpack_public_path__ + "static/media/tinyConnected.8dedb8f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tinyConnected.svg
// module id = 498
// module chunks = 0